import { computed} from '@vue/composition-api'
import { breakComma, formatDateKanji} from '@/util/common'

export const ServiceLicensePurchaseComplete = (props, context) => {
  const store = context.root.$store
  const { purchase } = store.state
  const { paymentList } = purchase

  const applicationNo = computed(() => store.getters['purchase/applicationNo'])

  const close = () => {
    context.emit('closeViewComplete')
  }

  return {
    breakComma,
    formatDateKanji,
    applicationNo,
    paymentList,
    close
  }
}
